<!-- Start: Rejwan: 18-05-2025 Deferred Settlements -->

<template>
    <div>
        <b-modal id="bv-modal-gf-overview" dialog-class="w-1200" hide-footer :title="title" size="lg">
            <b-overlay :show="showoverlay" rounded="sm">
                <div>
                    <div class="clearfix pl-0 col-md-12">
                        <div class="row justify-content-center modal-title">
                            <h5 class="modal-title text-center">{{ gf_profile_data.name }}</h5>
                        </div>
                        <div class="row justify-content-center pb-4">
                            Employees Gratuity Fund Scheme - {{ gf_profile_data.name }}
                        </div>
                        <!-- <div class='text-right mb-3' @click="getEmployeePfReport(gf_profile_data.employee_id)"><a href="#" class="px-3 py-1 border rounded" style="border:1px solid green !important; color: green;" ><i class="far fa-file-excel mr-1"></i> Download Schedule</a></div> -->
                        <div class="row col-12 no-margin px-0">
                            <div class="col-md-12">
                                <div class="ibox-content pf-overview px-0 pb-0">
                                    <div class="payslip-details-info-inner row">
                                        <template >
                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Employee ID</div>
                                                    <div class="second"> {{ gf_profile_data.employee_code }} </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Employee Name</div>
                                                    <div class="second"> {{ gf_profile_data.name }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Job Position</div>
                                                    <div class="second"> {{ gf_profile_data.jobposition }} </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Joining Date</div>
                                                    <div class="second"> {{ gf_profile_data.joining_date }} </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Leaving Date</div>
                                                    <div class="second"> {{ gf_profile_data.leaving_date }} </div>
                                                </div>
                                            </div>


                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Service Period</div>
                                                    <div class="second"> {{ gf_profile_data.service_period }} </div>
                                                </div>
                                            </div>

                                            <!-- <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">GF Eligibility Period</div>
                                                    <div class="second">{{ gf_profile_data.eligibility_period }}</div>
                                                </div>
                                            </div> -->

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">GF Amount Payable</div>
                                                    
                                                    <div class="second">{{ formatMoney(gf_profile_data.payable_amount) }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">GF Amount Settled</div>
                                                    
                                                    <!-- <div class="second">{{ formatMoney(gf_profile_data.settled_amount) }}</div> -->
                                                    <div class="second">{{ formatMoney(gf_profile_data.paid_amount) }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">Net GF Amount Payable</div>
                                                    <div class="second">{{ formatMoney(gf_profile_data.net_payable_amount) }}</div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Start: Rejwan: 19-05-2025 Manual De-registration -->
                <template v-if = "is_end == 1 || is_end == 2">
                    <b-form @submit.stop.prevent="endEmployeeGF">                    
                        <div class="clearfix">                                         
                            <div class="row clearfix">
                                <div class="col-md-6 mx-auto pt-4">                                         
                                    <b-form-group id="settlement_date-group" label="GF Enrollment End Date" label-for="settlement_date" class="required-field">
                                        <b-input-group class="mb-3">
                                            <b-form-input id="settlement_date"  :state="validateState('settlement_date')" name="settlement_date" v-model="curr_approve_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{required:true,date_format:'yyyy-MM-dd', after:min_date }"  aria-describedby="settlement_date-feedback" data-vv-as="Date"></b-form-input>
                                            <b-form-datepicker id="settlement_date" button-only right locale="en-US" v-model="curr_approve_date" :min="min_date"></b-form-datepicker>

                                            <b-form-invalid-feedback id="settlement_date-feedback">{{ veeErrors.first('settlement_date') }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                
                                </div> 
                                <div class="col-md-6 mx-auto pt-4">
                                    <b-form-group id="gf_reason-group" label="GF Separation Reason" label-for="gf_reason" class="required-field">
                                        <b-form-select id="gf_reason" name="gf_reason" v-model="gf_reason" v-validate="{ required: true }" :options="gf_reason_options" :aria-required="true"  placeholder="Please select" :state="validateState('gf_reason')">
                                            <b-form-invalid-feedback id="gf_reason">{{ veeErrors.first('gf_reason') }}</b-form-invalid-feedback>
                                        </b-form-select>
                                </b-form-group>
                                </div>
                            </div>                           
                        </div>
                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 0;">
                            <b-button class="btn border rounded bg-light px-5 btn-primary" type="submit" variant="primary">Submit</b-button>
                        </div>
                    </b-form> 
                </template>
                <!-- End: Rejwan: 19-05-2025 Manual De-registration -->

            </b-overlay>
        </b-modal>
    </div>

</template>

<script>
export default{
    props: ['pageurl','employee_id','title','show','is_end','curr_gf_id', 'gf_end_date', 'separation_reason', 'joining_date'],
    data(){      
        return {
            dreg_show:1,
            showoverlay:false,
            gf_profile_data:[],
            curr_emp_id:'',
            is_gf_settlement: 1,
            min_date:'', // Rejwan: 19-05-2025 Manual De-registration
            curr_approve_date:'', // Rejwan: 19-05-2025 Manual De-registration
            gf_reason_options: [],
            gf_reason: null,
        }
    },
    methods:{
        gfDetailsNew: function(employee_id)
        { 
            if(employee_id>0)
            {
                let currentObj = this;
                this.showoverlay = true;
                let formData = new FormData();
                formData.append('employee_id', employee_id);
                formData.append('from', 'gratutity_fund'); // Rejwan: 19-05-2025 GF Summery 
                // formData.append('viewmode', 1);
                // formData.append('d_type', 'excel'); 
                axios.post(this.$api_url + '/gf/profile-overview', formData)
                .then(function (response) 
                {
                    if(response.data === false) {
                        this.is_gf_settlement = 0;
                    } else {
                        this.gf_profile_data = response.data;

                        // Start: Rejwan: 19-05-2025 Manual De-registration
                        if(this.is_end == 1)
                        {
                            axios.get(this.$api_url + '/gf/active-separation-reasons')
                            .then(response => {
                                const options = response.data.map(item => ({
                                    value: item.id, 
                                    text: item.title
                                }));

                                // Add default option at the beginning
                                this.gf_reason_options = [
                                    { value: null, text: 'Please select' },
                                    ...options
                                ];

                                this.min_date = this.joining_date;
                            });
                        }
                        else if (this.is_end == 2) {

                            axios.get(this.$api_url + '/gf/active-separation-reasons')
                            .then(response => {
                                const options = response.data.map(item => ({
                                    value: item.id, 
                                    text: item.title
                                }));

                                this.min_date = this.joining_date;
                                // Add default option at the beginning
                                this.gf_reason_options = [
                                    { value: null, text: 'Please select' },
                                    ...options
                                ];

                                 const matched_option = this.gf_reason_options.find(
                                    option => option.text === this.separation_reason
                                );

                                this.gf_reason = matched_option ? matched_option.value : null;
                                this.curr_approve_date = this.gf_end_date;
                            });
                            
                        }
                        // End: Rejwan: 19-05-2025 Manual De-registration
                        this.showoverlay = false;
                        this.$bvModal.show('bv-modal-gf-overview');
                    }
                }.bind(this))
                .catch(function (error) 
                {
                }); 

            }
        },
        endEmployeeGF: function()
        {
            this.$validator.validateAll().then(result => 
            {
                if (!result) {        
                    return;
                }
                if(this.curr_gf_id && this.curr_approve_date)
                {
                    var curr_obj = this;
                    let formData = new FormData();
                    formData.append('id', this.curr_gf_id);
                    formData.append('employee_id', this.employee_id);
                    formData.append('gf_end_date', this.curr_approve_date);
                    formData.append('separation_reason', this.gf_reason);
                    axios.post(this.$api_url + '/gf/update-gf-data', formData)
                    .then(function (response) 
                    {
                        if(response.data == true){
                            curr_obj.$bvToast.toast("Successfully updated", {title: 'Success',variant: 'success',solid: true});
                            curr_obj.curr_emp_id =0;
                            curr_obj.curr_gf_id =0;
                            curr_obj.curr_approve_date ='';
                            this.$bvModal.hide('bv-modal-gf-overview');
                            this.$emit('childToParent');
                        }else if(response.data.errors){
                            curr_obj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});  
                        }
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.errormsg = error.response.data.errors;
                    }); 
                }
                else
                {
                    this.$bvToast.toast("Please choose employee and enter GF end date", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                }
            });
        },
    },
    created: function(){
          if(this.show > 0 && this.employee_id > 0)
          {
            this.gfDetailsNew(this.employee_id);
          }
    },
}
</script>

<!-- End: Rejwan: 18-05-2025 Deferred Settlements -->